import React from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

const Chart = ({ data, icon_link, icon_title, locale, recharts }) => {
  const { ResponsiveContainer, PieChart, Pie, Cell } = recharts;
  return (
    <ResponsiveContainer width={'100%'} height={500} className="pie-chart">
      {icon_link !== '/' && (
        <img src={icon_link} className="icon" alt={icon_title} />
      )}
      <PieChart>
        <Pie
          data={data}
          dataKey="v0"
          cx="50%"
          cy="50%"
          stroke="none"
          innerRadius={125}
          outerRadius={140}
          paddingAngle={0}
          startAngle={-270}
          border="none"
          labelLine={{ strokeWidth: 2 }}
          label={({
            cx,
            cy,
            midAngle,
            innerRadius,
            outerRadius,
            value,
            index,
          }) => {
            const RADIAN = Math.PI / 180;
            // eslint-disable-next-line
            const radius = 20 + innerRadius + (outerRadius - innerRadius);
            // eslint-disable-next-line
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            // eslint-disable-next-line
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            return (
              <>
                <text
                  x={x + (x > cx ? 16 : -16)}
                  y={y - 20}
                  fill="#000000"
                  textAnchor={x > cx ? 'start' : 'end'}
                  dominantBaseline="central"
                  fontWeight="300"
                  fontSize="60%"
                >
                  {data[index].name}
                </text>
                <line
                  x1={x}
                  y1={y}
                  x2={x + (x > cx ? 120 : -120)}
                  y2={y}
                  stroke={data[index].color}
                  strokeWidth="2"
                />
                <text
                  x={x + (x > cx ? 16 : -16)}
                  y={y + 24}
                  fill="#000000"
                  textAnchor={x > cx ? 'start' : 'end'}
                  dominantBaseline="central"
                  fontWeight="bold"
                  fontSize="140%"
                >
                  {Intl.NumberFormat(locale, {}).format(value)}%
                </text>
              </>
            );
          }}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default injectLazyLibs('recharts')(Chart);
